import React from 'react';
import './Hero.css';
import { styles } from '../styles';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGithub, faInstagram, faLinkedin, faFacebook } from '@fortawesome/free-brands-svg-icons';
import StarsCanvas from '../3d/Stars';
import cv from '../assets/cv.pdf';
import homeimg from '../../src/assets/image.png';
import { motion } from "motion/react"
const Hero = ({ theme }) => {
  return (
    <section className="relative w-full h-screen mx-auto bg-cover bg-center">

      <div className="home">
        <motion.div className="home-info"
         initial={{opacity:0.2,y:50}}
         transition={{duration:1}}
         whileInView={{opacity:1,y:0}}
         viewport={{once:true}}
        
        
        >
          <h1 className={`${styles.heroHeadText1} text-black`}>
            <span className="text-[#fff000]">Hello</span>, my name is <span className="text-[#000]">Amine Ajouihade</span>
          </h1>
          <h4 className={`${styles.heroSubText1} mt-2 text-gray-400`}>
            I am a Full Stack Web Developer and Designer,
            <br className="bg-gradient-to-r from-black via-gray-600 to-gray-600 text-transparent bg-clip-text" />
            with extensive experience in both front-end and back-end development.
          </h4>

          <div className="btn">
          <a
              className="group inline-block rounded-full bg-gradient-to-r from-[#ffff00] via-[#ffff00] to-yellow-500 p-[2px] hover:text-white"
              href={cv}
               download="cv_developer_amine"
            >
              <span className="block rounded-full bg-white px-6 py-2 sm:px-8 sm:py-3 text-sm group-hover:bg-transparent text-black font-bold">
              Download CV
              </span>
            </a>
            <div className="flex mt-2">
              <div className="sci">
                <a href="https://github.com/aminedevaj" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faGithub} style={{ fontSize: '20px', marginRight: '5px' }} />
                </a>
                <a href="https://www.instagram.com/amine_8a_/" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faInstagram} style={{ fontSize: '20px', marginRight: '5px', color: '#E1306C' }} />
                </a>
                <a href="https://www.linkedin.com/in/amine-ajouihade-211719308/" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faLinkedin} style={{ fontSize: '20px', marginRight: '5px', color: '#0077b5' }} />
                </a>
                <a href="https://www.facebook.com/profile.php?id=100088038682862" target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faFacebook} style={{ fontSize: '20px', marginRight: '5px', color: '#1877F2' }} />
                </a>
              </div>
            </div>
          </div>
        </motion.div>

        <div className="home-img">
          <div className="img-box">
            <div className="img-item">
              <img src={homeimg} alt="Profile" />
            </div>
          </div>
        </div>
      </div>
    </section>
    
  );
};

export default Hero;
